export type TransactionSuccessResponse = {
    AMOUNT: string;
    MESSAGE: string;
    ORDER_ID: string;
    PASREF: string;
    RESULT: string;
    TIMESTAMP: string;
};

export type TransactionFailureResponse = {
    error?: boolean;
    message?: string;
    MESSAGE?: string;
};

export type GlobalPaymentsResponse = TransactionSuccessResponse | TransactionFailureResponse;

// rxp-js wraps any unparseable postMessage as { error, message }, so extension chatter has to be filtered out here.
export function getGlobalPaymentsResponse(data: unknown): GlobalPaymentsResponse | null {
    if (typeof data !== "object" || data === null) {
        return null;
    }

    const { RESULT } = data as Partial<TransactionSuccessResponse>;
    if (typeof RESULT === "string") {
        return data as TransactionSuccessResponse;
    }

    const { MESSAGE, message } = data as TransactionFailureResponse;
    if (typeof MESSAGE === "string" || typeof message === "string") {
        return data as TransactionFailureResponse;
    }

    return null;
}

export function isSuccessResponse(response: GlobalPaymentsResponse): response is TransactionSuccessResponse {
    return "RESULT" in response;
}
